import React, { useEffect, useState } from 'react'

import styles from "./TransactionsHistory.module.scss"
import TransasctionHistoryItem from './TransasctionHistoryItem'
import { Button, List, Spin } from 'antd'
import Modal from "components/Modal/Modal";

export default function TransactionsHistory({ orderId,
    data, loading, loadTransactions
}) {
    const [showPopup, setShowPopup] = useState(false)
    useEffect(()=>{
        if(showPopup){
            loadTransactions()
        }
    }, [showPopup])
    return (
        <div style={{ padding: "20px 0px", paddingBottom: 0 }}>
            <div className={styles.transactionsHistoryHead}>
                <p className={styles.messageText} style={{ margin: 0 }}>Transactions History</p>
                <Button type='text' onClick={() => setShowPopup(true)} >View List</Button>
            </div>

            <Modal
                destroyOnClose={true}
                title="Transactions History"
                headerBorder={true}
                visible={showPopup}
                onCancel={() => setShowPopup(false)}
                className="boostPopup"
                footer={false}

            >
                <List
                    dataSource={data}
                    renderItem={(item, index) => {
                        return <TransasctionHistoryItem key={item.paymentId}
                            transactionHistory={item}
                        />
                    }}
                    style={{
                        gap: 12
                    }}
                    loading={loading}
                    locale={{
                        emptyText: "No Transactions",
                    }}
                />
            </Modal>


        </div>
    )
}
